import React from 'react';
import styles from './SectionPanel.module.css';
import accents from '../../pages/appointment/components/moduleCard/accents.module.css';

/**
 * Cartão de seção com ícone colorido, título e subtítulo, no desenho dos blocos
 * do card de atendimento. Usado tanto para leitura (ficha) quanto para formulário
 * (cadastro). `accent` segue as cores de `accents.module.css`; `aside` fica no
 * canto direito do cabeçalho (link, interruptor).
 */
function SectionPanel({ icon, title, subtitle, accent = 'blue', aside, className, children }) {
    return (
        <section className={`${styles.panel} ${accents[accent] || accents.blue} ${className || ''}`}>
            <header className={styles.header}>
                <span className={styles.icon}>{icon}</span>
                <div className={styles.titles}>
                    <span className={styles.title}>{title}</span>
                    {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
                </div>
                {aside && <div className={styles.aside}>{aside}</div>}
            </header>
            {children}
        </section>
    );
}

export default SectionPanel;
